import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AccountingDashboard } from "@/components/admin/AccountingDashboard";
import { CatalogPanel } from "@/components/admin/catalog/CatalogPanel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const Route = createFileRoute("/_authenticated/admin/export")({
  head: () => ({
    meta: [
      { title: "Админ — Export | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <div className="mx-auto max-w-6xl p-3 sm:p-6">
        <Tabs defaultValue="catalog" className="w-full">
          <TabsList>
            <TabsTrigger value="catalog">Каталог (PDF)</TabsTrigger>
            <TabsTrigger value="accounting">Счетоводство</TabsTrigger>
          </TabsList>
          <TabsContent value="catalog" className="mt-6">
            <CatalogPanel />
          </TabsContent>
          <TabsContent value="accounting" className="mt-6">
            <AccountingDashboard />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  ),
});
